import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@material-ui/core';
import Logo from './Logo';

const MainNavbar = (props) => (
  <AppBar
    elevation={0}
    sx={{background:"transparent"}}
    {...props}
  >
    <Toolbar sx={{ height: "70px !important", minHeight: "70px !important", background:"transparent", justifyContent:"center", alignItems:"flex-end" }}>
      <RouterLink to="/">
        <Logo />
      </RouterLink>
    </Toolbar>
  </AppBar>
);

export default MainNavbar;
